export const groups = {
    hour: 3600 * 1000,
    day: 86400 * 1000,
    week: 604800 * 1000,
    month: 2629743 * 1000,
    year: 31556926 * 1000,
};
